import { CLEAR_USER_DETAILS, SET_USER_DETAILS, USER_FAIL, USER_REQUEST, USER_SUCCESS } from '@/constants/userConstants'

export const userReducer = (state = { userDetails: {} }, action) => {
  switch (action.type) {
    case USER_REQUEST:
      return { loading: true, userDetails: {} }
    case USER_SUCCESS:
      return {
        loading: false,
        userDetails: action.payload
      }
    case USER_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

/**
 * Authenticated User Details Reducer
 * Stores user details from authentication that can be accessed outside React components
 * Note: activeViews (role and scopes) are computed from user details, not stored separately
 */
export const authenticatedUserReducer = (
  state = {
    user: null,
    isAuthenticated: false
  },
  action
) => {
  switch (action.type) {
    case SET_USER_DETAILS:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true
      }
    case CLEAR_USER_DETAILS:
      return {
        user: null,
        isAuthenticated: false
      }
    default:
      return state
  }
}
